import React from "react";
import { useSelector } from 'react-redux';
import addtoMyAnalog from "../../../src/img/icons/addtoMyAnalog.svg";
import ToolTip from "../ToolTip";

export const AddToMyCartIcon = (props) => {
  const addToMyCartLabel = useSelector(state => state.labels.button.addToMyCart);
  /**
   * Redirects the user to product page with the sample and buy section open
   */
  const redirectToMyCart = () => {
    if (props.url) {
      window.open(props.url, '_blank')
    }
  };

  return (
    <span className="parts__tooltip-wrapper">
      <ToolTip label={addToMyCartLabel} />
      <img
        width={props.mobile ? "40" : "24"}
        height={props.mobile ? "40" : "24"}
        key={props.url}
        src={addtoMyAnalog}
        onClick={redirectToMyCart}
        alt={addToMyCartLabel}
        tabIndex={0}
        role="button"
      />
    </span>

  );
};
